// extracted by mini-css-extract-plugin
export var screens = "screens-module--screens--ClQfb";
export var head = "screens-module--head--2SirZ";
export var head_leftSvg = "screens-module--head_leftSvg--da-VF";
export var head_rightSvg = "screens-module--head_rightSvg--3YZCC";
export var head_mobileSvg = "screens-module--head_mobileSvg--1qXZ3";
export var title = "screens-module--title--3vusv";
export var jsAnimInit = "screens-module--jsAnimInit--2vt0A";